module.exports = __webpack_public_path__ + "img/888D8F_515454_646A6C_6C6C6D-256px.913a6e04.png";